// @flow
import React from 'react'
import styled from 'styled-components'
import type {Node} from 'react'


type Props = {
    title: string,
    children: Node
}

export default function Feature (props:Props) {
    return (
        <Wrapper>
            <Title>{props.title}</Title>
            <Content>{props.children}</Content>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;
    margin-bottom: 10px;
`

const Title = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`

const Content = styled.div`
    flex: 2;
`


// WEBPACK FOOTER //
// ./src/config/Feature.js